import { Injectable } from '@angular/core';
import { FirebaseData } from '../providers/firebase-data';
import { FirebaseStorage } from '../providers/firebase-storage';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../providers/utils';
import { LocalStorageCodes } from '../core/codes';
import { Storage } from '@ionic/storage'; 
import { AppSettings } from '../config/app-settings';
import firebase from 'firebase';

@Injectable()
export class FeedData {
    public realtimeDb: any;

    constructor(
        private firebaseData: FirebaseData, 
        private firebaseStorage: FirebaseStorage,
        private storage: Storage,
        public settings: AppSettings
        ) {
    	this.realtimeDb = firebase.database();
    }

    public getAllPosts(eventId, numofRecords){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('posts/'+ eventId ).limitToLast(numofRecords).once('value', data => {
                let posts = [];
                if(data){
                    posts = Utils.toArray(data.val()).reverse();
                }
                observer.next(posts);
            });
        });
    }

    public getFeaturedPosts(numofRecords){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('news').limitToLast(numofRecords).once('value', data => {
                let posts = [];
                if(data){
                    posts = Utils.toArray(data.val()).reverse();
                }
                observer.next(posts);
            });
        });
    }

    public getFeaturedEvents(numofRecords){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('events').limitToLast(numofRecords).once('value', data => {
                let posts = [];
                if(data){
                    posts = Utils.toArray(data.val()).reverse();
                }
                observer.next(posts);
            });
        });
    }

    public listenForNewPosts(){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('posts').limitToLast(1).on('child_added', data => {
                if(data){
                    observer.next({key: data.key, value: data.val()});
                }
            });
        });
    }

    public setAllOfflinePosts(posts){
        this.storage.set(LocalStorageCodes.LOADED_POSTS, JSON.stringify(posts));
    }
    
    public getAllOfflinePosts(){
        return Observable.create((observer) => {
          this.storage.get(LocalStorageCodes.LOADED_POSTS).then((value) => {
            observer.next(value ? JSON.parse(value) : null);
          });
        });
    }

    public setAllOfflinePostsByUser(uid, posts){
        this.storage.set(LocalStorageCodes.LOADED_POSTS + ":" + uid, JSON.stringify(posts));
    }
    
    public getAllOfflinePostsByUser(uid){
        return Observable.create((observer) => {
          this.storage.get(LocalStorageCodes.LOADED_POSTS  + ":" + uid).then((value) => {
            observer.next(value ? JSON.parse(value) : null);
          });
        });
    }

    public getPostUser(postId){

    }

    public getAllPostsByUser(uid, numofRecords){
    	var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('user-posts/'+uid).limitToLast(numofRecords).once('value', data => {
                let posts = [];
                if(data){
                    posts = Utils.toArray(data.val());
                    posts = posts.reverse();
                }
                observer.next(posts);
            });
        });
    }
    
    public getPostMedia(postId){
    	return Observable.create((observer) => {
	  		this.realtimeDb.ref('post-media').child(postId).once('value', data => {
	  			observer.next(data.val());
	  		});
	  	});    
    }

    public getPostLikes(postId){
        return Observable.create((observer) => {
              this.realtimeDb.ref('post-likes').child(postId).once('value', data => {
                  observer.next(Utils.toArray(data.val()));
              });
          });    
    }

    public getPostComments(postId, numofRecords=-1){
        return Observable.create((observer) => {
            if(numofRecords === -1){
                this.realtimeDb.ref('post-comments').child(postId).once('value', data => {
                  observer.next(Utils.toArray(data.val()));
              });
            }else{
                this.realtimeDb.ref('post-comments').child(postId).limitToLast(numofRecords).once('value', data => {
                      observer.next(Utils.toArray(data.val()));
                  });
            }
        });
    }

    public addPostComments(post, commentData){
        return Observable.create((observer) =>{
            // Get a key for a new Post.
            var timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
            commentData.timestampCreated = timeStamp

            var newCommentKey = firebase.database().ref().child('post-comments/'+ post.key).push(commentData).key;

            // Update comment count
            post.value.commentCount ++;
            if(!post.comments){post.comments = [];}
            if(newCommentKey){
                post.comments.push({key: newCommentKey, value: commentData});
            }

            var updates = {};
            updates['/posts/' + post.value.eventId + '/' + post.key] = post.value;
            updates['/user-posts/' + post.value.uid + '/' + post.key] = post.value;

            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(newCommentKey);
            }, function(error){
                observer.next(false);
            });
        });
    }

    public updatePostMedia(postId, mediaData){
        return Observable.create((observer) => {
            var updates = {};
            updates['/post-media/' + postId] = mediaData;

            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(true);
            }, function(error){
                observer.next(false);
            });
        });
    }

    public updatePostLike(postId, uid, postData, isLike, myLike){
        return Observable.create((observer) => {
            let postLikeKey = "";

            if(isLike){
                // Add a like entry
                postLikeKey = firebase.database().ref().child('post-likes/'+postId).push().key;
            }
            var updates = {};
            updates['/posts/' + postData.eventId + '/' + postId] = postData;
            updates['/user-posts/' + postData.uid + '/' + postId] = postData;
            if(isLike){
                updates['/post-likes/' + postId + '/' + postLikeKey] = {uid: uid};
            }else{
                updates['/post-likes/' + postId + '/' + myLike.key] = null;
            }

            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(postLikeKey);
            }, function(error){
                observer.next(false);
            });
        });
    }

    public updatePost(postId, postData){
        return Observable.create((observer) => {
            
            var updates = {};
            updates['/posts/' + postData.eventId + '/' + postId] = postData;
            updates['/user-posts/' + postData.uid + '/' + postId] = postData;
            
            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(true);
            }, function(error){
                observer.next(false);
            });
        });
    }
    
    public addPost(uid, formData, formMedia){
    	return Observable.create((observer) =>{
            // Get a key for a new Post.
            var newPostKey = firebase.database().ref().child('posts').push().key;
            var updates = {};
            
            // Get timestamp

            var timeStamp = (<any>firebase.database).TIMESTAMP;
            formData.timestampCreated = timeStamp;

            // Upload Images if any
            var postMedia: any;
            if(formMedia){
                var path = this.settings.feedImageDirectory + '/' + uid+'/'+newPostKey+'/';
                
                this.firebaseStorage.uploadFile(path, formMedia).subscribe(image => {
                    //Flag post that it has media
                    formData.hasMedia = true;
                    postMedia = {
                        "url": image.url,
                        "viewCount": 1,
                        "type": "image",
                        "timestampCreated": timeStamp
                    };
                    //Upload with Images
                    updates['/post-media/' + newPostKey]                      = postMedia;
                    updates['/posts/' + formData.eventId + '/'+ newPostKey]   = formData;
                    updates['/user-posts/' + uid + '/' + newPostKey]          = formData;

                    this.realtimeDb.ref().update(updates).then(function(){
                        observer.next({'post': {key:newPostKey, value:formData}, 'media': {key: newPostKey, value: postMedia}});
                    }, function(error){
                        observer.next(false);
                    });
                });         
            }else{
                // Just upload posts
                updates['/posts/' + formData.eventId + '/' + newPostKey]  = formData;
                updates['/user-posts/' + uid + '/' + newPostKey]          = formData;
            
                this.realtimeDb.ref().update(updates).then(function(){
                    observer.next({'post': {key: newPostKey, value: formData}, 'media': null});
                }, function(error){
                    observer.next(false);
                });
            }
    	});
    }
   
    public deletePost(uid, eventId, postId){
    	return Observable.create((observer) => {
    		var updates = {};
            updates['/posts/' + eventId + '/' + postId]     = null;
            updates['/user-posts/' + uid + '/' + postId]    = null;
            updates['/post-media/' + postId]                = null;

            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(true);
            }, function(error){
                observer.next(false);
            });
    	})
    }    
}


// WEBPACK FOOTER //
// ./src/providers/feed-data.ts